<template>
	<div class="full page_container">

		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="采购" v-if="findChildren(131)!==-1" name="purchaserelationflow" style="height: 100%;">
				<purchaserelationflow-index />
			</el-tab-pane>
			<el-tab-pane label="售后" v-if="findChildren(158)!==-1" name="exchangeimprest" style="height: 100%;">
				<exchangeimprest-index />
			</el-tab-pane>
			<el-tab-pane label="行政" v-if="findChildren(159)!==-1" name="administrationimprest" style="height: 100%;">
				<administrationimprest-index />
			</el-tab-pane>
		</el-tabs>


	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import purchaserelationflowIndex from './purchaserelationflow/index.vue'
	import exchangeimprestIndex from './exchangeimprest/index.vue'
	import administrationimprestIndex from './administrationimprest/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				activeName: '',
				activeIndex: '',
				departmentChildren: []
			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			if (this.departmentChildren.length != 0) {
				this.activeName = this.departmentChildren[0].controller
				//this.activeName = 'purchasestockbill'
			}
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			}
		},
		components: {
			purchaserelationflowIndex,
			exchangeimprestIndex,
			administrationimprestIndex
		}
	}
</script>